// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"rdg_9f63d5b4","headline":"rdg_d5c33312"};